import * as Constants from '../../../../constants';
import * as Utils from '../../../../utils';

const { bindKey, unBindKeySet } = Utils.Keyboard;
const { KeySetKeys, MousetrapKeys } = Constants.Keyboard;

export function bindKeys({ moveUp, moveDown, selectItem, closeDropdown }) {
  bindKey({
    keySet: KeySetKeys.AUTOCOMPLETE,
    key: MousetrapKeys.UP,
    handler: moveUp,
    isGlobal: true,
  });

  bindKey({
    keySet: KeySetKeys.AUTOCOMPLETE,
    key: MousetrapKeys.DOWN,
    handler: moveDown,
    isGlobal: true,
  });

  bindKey({
    keySet: KeySetKeys.AUTOCOMPLETE,
    key: MousetrapKeys.TAB,
    handler: moveDown,
    isGlobal: true,
  });

  bindKey({
    keySet: KeySetKeys.AUTOCOMPLETE,
    key: MousetrapKeys.SHIFT_TAB,
    handler: moveUp,
    isGlobal: true,
  });

  bindKey({
    keySet: KeySetKeys.AUTOCOMPLETE,
    key: MousetrapKeys.ENTER,
    handler: selectItem,
    isGlobal: true,
  });

  bindKey({
    keySet: KeySetKeys.AUTOCOMPLETE,
    key: MousetrapKeys.ESC,
    handler: closeDropdown,
    isGlobal: true,
  });
}

export function unbindKeys() {
  unBindKeySet(KeySetKeys.AUTOCOMPLETE);
}
